/* eslint-disable */
import React, {
    useRef,
    useEffect
} from "react";
// import { Button, } from "@mui/material";
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { Downgraded } from '@hookstate/core';
import { useAuthState } from '../../../stores/authStore';
import CustomDialog from "../../../sharedcomponents/dialog/dialog";
import ButtonContainer from "../../../sharedcomponents/buttoncontainer/buttonContainer";
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from "../../../config/config";

// import { ConstructionOutlined } from "@mui/icons-material";
// import Title from "../../../sharedcomponents/title/title";

import translations from "../../../config/adyenCardConfig";
import { Box, Card, CardContent, FormControlLabel, Radio, TextField, Typography } from "@mui/material";
import Title from "../../../sharedcomponents/title/title";
import TitleWithoutNBAAction from "../../../sharedcomponents/title/titlewithoutnbaaction";
import Helper from "../../../utility/helper";
const AddCreditCard = (props) => {
    
    const authState = useAuthState();
    const paymentContainer = useRef(null);
    const newPaymentContainer = useRef(null);
    // const [cardInfo, setCardInfo] = React.useState(null);
    const [enableAdd, setEnableAdd] = React.useState(true);
    const [checkoutObj, setCheckoutObj] = React.useState(null);
    const [shopperRefID, setShopperRefID] = React.useState('');
    const [selectedOption, setSelectedOption] = React.useState(-1);
    const logoURL = process.env.REACT_APP_CREDIT_LOGOS;
    const [email, setEmail] = React.useState('')
    const cardEmail = useRef('')
    const [emailErr, setEmailErr] = React.useState('')

    
    useEffect(() => {
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();

        const configuration = {
            locale: "en-US",
            translations: translations,
            environment: authStateInfo.environment,
            clientKey: authStateInfo.clientKey,
            showPayButton: true,
            // enableStoreDetails: true,
            // recurringProcessingModel: "CardOnFile",
            // onChange: handleOnChange,
            onError: handleError,
            onSubmit: handleSubmit,
            // onPaymentCompleted: handlePaymentCompleted,
            onFieldValid: handleFieldValid,
            paymentMethodsConfiguration: {
                card: {
                    hasHolderName: true,
                    holderNameRequired: true,
                    enableStoreDetails: true,
                    // billingAddressRequired: true
                },
            }
            // onConfigSuccess: handleOnLoad
        };
        function handleFieldValid(state, card) {
            // console.log('state field : ', state);
            // console.log('state field card : ', card);
        }
        // function handleOnChange(state, component) {
        //     console.log('isValid : ', state.isValid) // True or false. Specifies if all the information that the shopper provided is valid.
        //     // console.log('data : ', state.data) // Provides the data that you need to pass in the `/payments` call.
        //      // Provides the active component instance that called this event.
        //     if (state.isValid == true) {
        //         setCardInfo(state.data.paymentMethod);
        //         console.log('component : ', component);
        //         setEnableAdd(false);
        //     }
        //     if (state.isValid == false) {
        //         setCardInfo(null);
        //         setEnableAdd(true);
        //     }
        // }

        function handleSubmit(state) {
            // console.log('submit button : ', state,email);
            
            // if(email.length == 0){
            //     setEmailErr('Please Enter Email');
            //     return false
            // } else{
                if (state.isValid == true) {               
                    handleClick(state.data);
                          
                    
                    // setCardInfo(state.data.paymentMethod);
                    // setTimeout(() =>
                    //     handleClick()
                    // , 2000);
                    // console.log('component : ', component);
                    // setEnableAdd(false);
                }
            // }
            
            // if (state.isValid == false) {
            //     setCardInfo(null);
            //     // setEnableAdd(true);
            // }
        }

        // function handlePaymentCompleted(result, component) {
        //     console.log('inside payment complete');
        //     console.info(result, component);
        // }

        function handleError(error, component) {
            console.error(error.name, error.message, error.stack, component);
        }

        const createCheckout = async () => {
            const checkout = await AdyenCheckout(configuration);
            // for existing cards create new card
            if (props.prevCreditCards && props.prevCreditCards.length > 0) {
                if (paymentContainer.current) {
                    setTimeout(() => {
                        checkout.create('card', {
                            showStoredPaymentMethods: true, // check on this setting
                            brands: ['mc', 'visa', 'amex', 'diners', 'discover', 'maestro']
                        }).mount(paymentContainer.current);
                        setCheckoutObj(checkout);
                    }, 100);
                }
            }// for new card 
            else {
                if (newPaymentContainer.current) {
                    setTimeout(() => {
                        checkout.create('card', {
                            showStoredPaymentMethods: true, // check on this setting
                            brands: ['mc', 'visa', 'amex', 'diners', 'discover', 'maestro']
                        }).mount(newPaymentContainer.current);
                        setCheckoutObj(checkout);
                    }, 100);
                }
            }
        }
        if (props.shopperRefID)
            setShopperRefID(props.shopperRefID)
        else
            setShopperRefID('');

        createCheckout();

    }, []);

    const handleChange = (event, item) => {
        setSelectedOption(event.target.value);
        if (item) {
            const obj = {
                creditCardID: item.creditCardID,
                summary: item.cardNo,
                token: '',
                reference: '',
                brand: item.brand,
                store: true,
                cardName: item.cardName
            }
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'success',
                message: 'You have selected the card',
            });
            props.setShowCardValidationMessage(false);
            props.storeCardInfo(obj);
            handleClose();
        }
    };
    const onEmailChange = (value) => {
        setEmail(value)
        cardEmail.current = value
        if (value.trim() == '') {
            setEmailErr('Please Enter Email');
        } else if (!Helper.validEmail(value)) {
            setEmailErr('Please Enter valid Email');
        } else {
            setEmailErr('');
        }
    }
    const renderDialogContent = () => (
        <Box sx={{
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column'
        }}>
            {props.existingCard ?
                <Typography variant="subtitle2" sx={{ pb: 1 }}>You can add new card entry or keep the existing card detail</Typography>
                : null}
            {props.prevCreditCards && props.prevCreditCards.length > 0 ?
                <>
                    {props.prevCreditCards.map((item, index) => {
                        return (
                            <Card key={`cardselect_${index}`} sx={{ mb: 1 }}>
                                <CardContent sx={{ marginBottom: '-24px', pl: 1, pr: 1 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <Radio
                                            checked={selectedOption == index}
                                            onChange={(event) => handleChange(event, item)}
                                            value={index}
                                            sx={{ pb: 1 }}
                                        />
                                        <img src={`${logoURL}${item.brand}.svg`} width='24' height={16} />

                                        <TitleWithoutNBAAction title={` **** - ${item.cardNo} - `} />
                                        <TitleWithoutNBAAction title={`${item.cardName}`} />
                                    </Box>
                                </CardContent>
                            </Card>
                        )
                    })}
                    <Card sx={{ mb: 1 }}>
                        <CardContent sx={{ pb: 0, pt: 1, pl: 1, pr: 1 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Radio
                                    checked={selectedOption == props.prevCreditCards.length}
                                    onChange={(event) => handleChange(event, null)}
                                    value={props.prevCreditCards.length}
                                />
                                <TitleWithoutNBAAction title={'New card details'} />                                
                            </Box>
                            {selectedOption == props.prevCreditCards.length ? getEmailComponent() : null}                      
                            <div ref={paymentContainer} style={(selectedOption == props.prevCreditCards.length && (email != "" && emailErr == "")) ? { opacity: '1' } : { pointerEvents: 'none', opacity: '0.5' }}></div>                            
                        </CardContent>
                    </Card>
                </>
                :
                <><Box>
                    {getEmailComponent()}
                    <div ref={newPaymentContainer} style={(email != "" && emailErr == "") ? { opacity: '1' } : { pointerEvents: 'none', opacity: '0.5' }}></div>                    
                </Box></>
                
            }
        </Box>
    );

    function getEmailComponent () {
        return(
            <TextField
                size="small"
                id="outlined-required"
                label="Email"
                autoComplete="off"
                value={email}
                onChange={(event) => {
                    onEmailChange(event.target.value)
                }}
                onBlur={(event) => {
                    onEmailChange(event.target.value)
                }}
                fullWidth
                error={
                    emailErr.length > 0 ? true : false
                }
                helperText={emailErr}
                inputProps={{ maxLength: 50 }}
                required={true}
            />
        )
    }

    const renderDialogActions = () => (<></>
        // <ButtonContainer
        //     handleClick={handleClick}
        //     handleCancel={handleClose}
        //     buttonText={'Add'}
        //     disableButton={enableAdd}
        //     disableCancel={false}
        // />
    );

    const handleClick = (reqdata) => {
        // console.log('check : ', cardInfo);
        const cardInfo = reqdata.paymentMethod;

        // checkoutObj.onSubmit(state => {
        //     console.log('on submit log : ', state);
        // })

        const request = {
            type: cardInfo.type,
            holderName: cardInfo.holderName,
            encryptedCardNumber: cardInfo.encryptedCardNumber,
            encryptedExpiryMonth: cardInfo.encryptedExpiryMonth,
            encryptedExpiryYear: cardInfo.encryptedExpiryYear,
            encryptedSecurityCode: cardInfo.encryptedSecurityCode,
            userID: props.connection, // temp fix for getting proper shopper referenceid
            eventID: props.eventID,
            connection: props.userID, // temp fix for getting proper shopper referenceid
            store: reqdata.storePaymentMethod,
            email: cardEmail.current
        };
        // debugger
        ApiHelper.post(APIURLConstants.POST_PAYMENT_METHOD, request)
            .then((res) => {
                const data = res.data;
                if (data && data.resultCode == "Authorised") {
                    const obj = {
                        summary: data.additionalData.cardSummary,
                        token: data.additionalData['recurring.recurringDetailReference'],
                        reference: data.additionalData['recurring.shopperReference'],
                        brand: data.additionalData.paymentMethod,
                        store: reqdata.storePaymentMethod,
                        cardName: cardInfo.holderName,
                        email: cardEmail.current
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Your card is authorized',
                    });
                    props.setShowCardValidationMessage(false);
                    props.storeCardInfo(obj);
                    handleClose();
                }
                else {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'We are sorry, your card could not be added. Please re-enter your card details, use a different card, or contact your financial institution.',
                    });
                    props.setShowCardValidationMessage(false);
                    handleClose();
                }
            })
            .catch((err) => {
                console.log('err', err);
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'There is an problem with Adyen server, please try after sometime.',
                });
                handleClose();
            });
    }

    const handleClose = () => {
        props.hideCreditCard(false);
    }
    return (
        <>
            <CustomDialog
                title={'Card Details'}
                handleClose={handleClose}
                open={props.showCreditCard}
                fullWidth={true}
                maxWidth={'sm'}
                showClose={true}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}
                addNote={'By clicking "Save", you understand that your card information will be securely stored for future purchases'}
            />
        </>
    );
}

export default AddCreditCard;